<template>
  <div>
    <div v-if="isAtInitialization()">
      <UsernameRetrievalInitialization
        @onReceiveMultipleUsernames="onRecieveMultipleUsernames"
        @onReceiveNoUsernames="onRecieveNoUsername"
      >
      </UsernameRetrievalInitialization>
    </div>
    <div v-if="isAtChoice()">
      <UsernameRetrievalChoice
        :username-radio-items="usernames"
      ></UsernameRetrievalChoice>
    </div>
    <div v-if="isAtNoUsernameFound()">
      <UsernameRetrievalNoUsername></UsernameRetrievalNoUsername>
    </div>
  </div>
</template>

<script setup lang="ts">
import UsernameRetrievalInitialization from '@/components/account-management/publicusernameretrieval/PublicUsernameRetrievalInitialization.vue'
import UsernameRetrievalChoice from '@/components/account-management/publicusernameretrieval/PublicUsernameRetrievalChoice.vue'
import UsernameRetrievalNoUsername from '@/components/account-management/publicusernameretrieval/PublicUsernameRetrievalNoUsername.vue'
import { ref } from 'vue'

enum RetrievalState {
  INITIALIZATION,
  USERNAME_CHOICE,
  NO_USERNAME_FOUND
}

const retrievalStatus = ref(RetrievalState.INITIALIZATION)
const usernames = ref<string[]>()

const onRecieveMultipleUsernames = (_usernames: string[]): void => {
  if (!_usernames) {
    console.error('Invalid response')
    return
  }
  usernames.value = _usernames
  retrievalStatus.value = RetrievalState.USERNAME_CHOICE
}

const onRecieveNoUsername = (): void => {
  retrievalStatus.value = RetrievalState.NO_USERNAME_FOUND
}

function isAtInitialization(): boolean {
  return retrievalStatus.value === RetrievalState.INITIALIZATION
}

function isAtChoice(): boolean {
  return retrievalStatus.value === RetrievalState.USERNAME_CHOICE
}

function isAtNoUsernameFound(): boolean {
  return retrievalStatus.value === RetrievalState.NO_USERNAME_FOUND
}
</script>
